import { memo } from 'react';
import Svg, { Path } from 'react-native-svg';
import { useResponsiveContext } from '../functions/responsive/ResponsiveContext';
import { useIsDarkMode } from './UserInterfaceIdiomContext';

export const BackIcon = memo(
  ({ fill, ...props }: { fill?: string; size?: number }) => {
    const { rpx } = useResponsiveContext();
    const isDarkMode = useIsDarkMode();
    if (fill == null) {
      fill = isDarkMode ? '#fff' : '#000';
    }
    const size = props.size ?? rpx(50);
    return (
      <Svg width={size} height={size} viewBox="0 0 50 50" fill={fill}>
        <Path
          d="M31.8236 23.8236L21.3527 23.8236L25.1681 20.0083C25.6273 19.5491 25.6273 18.8037 25.1681 18.3444C24.7088 17.8852 23.9634 17.8852 23.5042 18.3444L17.6805 24.1681C17.2213 24.6273 17.2213 25.3727 17.6805 25.832L23.5041 31.6556C23.9634 32.1148 24.7088 32.1148 25.168 31.6556C25.6269 31.1968 25.6273 30.4509 25.168 29.9917L21.3527 26.1764L31.8236 26.1764C32.4734 26.1764 33 25.6497 33 25C33.0004 24.3506 32.473 23.8232 31.8236 23.8236Z"
          fill={fill}
        />
      </Svg>
    );
  },
);
